import { Injectable, inject } from '@angular/core';

import { Fai, Plan } from '@bytel/bytel-sales';
import { UserService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';
import { MessageService } from '@services/message.service';

import { ConfigurationService } from '../services/configuration.service';
import { FaiService } from '../services/fai.services';
import { EligiblityErrorModalComponent } from '../shared/eligiblity-error-modal/eligiblity-error-modal.component';
import { FaiErrorModalComponent } from '../shared/fai-error-modal/fai-error-modal.component';

@Injectable({
    providedIn: 'root',
})
export class UserEligibiltyResolver {
    private userService: UserService = inject(UserService);
    private cartService: MainCartService = inject(MainCartService);
    private messageService: MessageService = inject(MessageService);
    private faiService: FaiService = inject(FaiService);
    private configService: ConfigurationService = inject(ConfigurationService);

    public async resolve(): Promise<void> {
        if (this.userService.user && this.userService.getStoredUserData()) {
            const quoteFix = this.cartService.getQuoteFai();
            if (!quoteFix) {
                return;
            }
            const isUserEligibleLimitedRange = await this.userService.isUserEligibleLimitedRange(
                this.cartService.cartModel,
            );
            if (!isUserEligibleLimitedRange) {
                this.messageService.openModal(EligiblityErrorModalComponent, {
                    commercialSeries: (quoteFix.getPrincipalProduct(Plan) as Fai)?.data.commercial_series,
                    user: this.userService.user,
                });
            }

            if (this.configService.getData().global.shouldCheckFTTH) {
                const canSubscribe = await this.userService.canSubscribeToFai({
                    hexaKey: this.faiService.eligibility.address.hexaKey,
                    inseeCode: this.faiService.eligibility.address.city.INSEECode,
                    postalCode: this.faiService.eligibility.address.zipCode,
                    rivoliCode: this.faiService.eligibility.address.street.rivoliCode,
                });

                if (!canSubscribe) {
                    this.messageService.openModal(FaiErrorModalComponent);
                    return null;
                }
            }
        }
    }
}
